/** @format */

import { ILocation } from "lobbie";
import { useCallback, useMemo } from "react";
import SchedulingLocationCard from "src/components/shared/scheduling/cards/SchedulingLocationCard";
import { IS_MOBILE_PHONE } from "src/constants";

import { usePatientSelfSchedulingContext } from "src/hooks/patient_scheduling/usePatientSelfSchedulingContext";
import { isEmptyObject } from "src/utils";

const PatientSchedulingLocations = () => {
    const { selfScheduleSettings, selfSchedule, setSelfSchedule, route, setRoute, getNextRoute } =
        usePatientSelfSchedulingContext();

    const handleSetSelected = useCallback(
        (newLocation: ILocation | null) => {
            if (!selfSchedule) return;
            setSelfSchedule({
                ...selfSchedule,
                appointmentType: selfSchedule.appointmentType,
                location: newLocation,
            });
            setRoute(newLocation !== null ? getNextRoute() : route);
        },
        [getNextRoute, route, selfSchedule, setRoute, setSelfSchedule],
    );

    const render = useMemo(() => {
        const locs = [];
        const incrementor = IS_MOBILE_PHONE ? 1 : 2;
        for (
            let i = 0;
            i <
            (selfScheduleSettings?.locations && Array.isArray(selfScheduleSettings?.locations)
                ? selfScheduleSettings.locations
                : []
            ).length;
            i += incrementor
        ) {
            if (selfScheduleSettings?.locations === undefined) continue;
            const loc = selfScheduleSettings?.locations[i];

            if (IS_MOBILE_PHONE) {
                locs.push(
                    <SchedulingLocationCard
                        key={loc.id}
                        location={loc}
                        selected={loc.id === (selfSchedule?.location?.id ?? null)}
                        setSelected={handleSetSelected}
                        //TODO: LOBBIE-3373 Maybe some JS-fu i'm unfamiliar with for second error
                        nextAvailable={
                            selfScheduleSettings.locationPractitioners.hasOwnProperty(
                                "next" + loc.id,
                            )
                                ? (selfScheduleSettings.locationPractitioners[
                                      "next" + loc.id
                                  ] as string)
                                : ""
                        }
                    />,
                );
                continue;
            }
            const nextLoc = selfScheduleSettings?.locations[i + 1];
            locs.push(
                <div key={loc.id} className="row">
                    <div className="col-6">
                        <SchedulingLocationCard
                            location={loc}
                            selected={loc.id === selfSchedule?.location?.id}
                            setSelected={handleSetSelected}
                            //@ts-ignore
                            nextAvailable={
                                selfScheduleSettings.locationPractitioners.hasOwnProperty(
                                    "next" + loc.id,
                                )
                                    ? (selfScheduleSettings.locationPractitioners[
                                          "next" + loc.id
                                      ] as string)
                                    : ""
                            }
                        />
                    </div>
                    {nextLoc && (
                        <div className="col-6">
                            <SchedulingLocationCard
                                location={nextLoc}
                                selected={nextLoc.id === selfSchedule?.location?.id}
                                setSelected={handleSetSelected}
                                //@ts-ignore
                                nextAvailable={
                                    selfScheduleSettings.locationPractitioners.hasOwnProperty(
                                        "next" + nextLoc.id,
                                    )
                                        ? (selfScheduleSettings.locationPractitioners[
                                              "next" + nextLoc.id
                                          ] as string)
                                        : ""
                                }
                            />
                        </div>
                    )}
                </div>,
            );
        }
        return locs;
    }, [
        selfScheduleSettings?.locations,
        selfScheduleSettings?.locationPractitioners,
        selfSchedule?.location?.id,
        handleSetSelected,
    ]);

    if (isEmptyObject(selfScheduleSettings?.locations)) {
        const message = (() => {
            if (selfScheduleSettings?.accountName) {
                return `Sorry, we could find not find a location for ${selfScheduleSettings?.accountName} that has any availability for self-scheduling.`;
            }
            return "Sorry, we could find not find a location that has any availability for self-scheduling.";
        })();
        return (
            <div className="container-fluid">
                <h3>{"No locations found."}</h3>
                <p>{message}</p>
            </div>
        );
    }

    return (
        <div className="container-fluid">
            <h3 className="extra-bold mt-4">
                {"Select your"}
                <br />
                {"location:"}
            </h3>
            {render}
        </div>
    );
};

export default PatientSchedulingLocations;
